<template>
  <svg viewBox="0 0 1024 1024" fill="currentColor">
    <path
      d="M728.32 914.9952H314.5728a196.3008 196.3008 0 0 1-196.096-196.1472V305.1008a196.3008 196.3008 0 0 1 196.096-196.096h413.7472a196.3008 196.3008 0 0 1 196.1472 196.096v413.7472a196.352 196.352 0 0 1-196.1472 196.1472zM314.5728 180.6848a124.5696 124.5696 0 0 0-124.416 124.416v413.7472a124.5696 124.5696 0 0 0 124.416 124.4672h413.7472a124.5696 124.5696 0 0 0 124.4672-124.4672V305.1008a124.5696 124.5696 0 0 0-124.4672-124.416z"
    />
    <path
      d="M521.472 758.0672a35.84 35.84 0 0 1-35.84-35.84v-332.288a35.84 35.84 0 0 1 71.68 0v332.288a35.84 35.84 0 0 1-35.84 35.84zM350.8736 758.0672a35.84 35.84 0 0 1-35.84-35.84v-141.8752a35.84 35.84 0 0 1 71.68 0v141.8752a35.84 35.84 0 0 1-35.84 35.84zM692.0704 758.0672a35.84 35.84 0 0 1-35.84-35.84V505.9072a35.84 35.84 0 0 1 71.68 0v216.32a35.84 35.84 0 0 1-35.84 35.84z"
    />
  </svg>
</template>
